export enum Locale {
  EN = 'en',
  ID = 'id',
}

export enum LangDisplay {
  EN = 'ENG',
  ID = 'ID',
}
export type LangType = Locale;
export type LangDisplayType = LangDisplay;

export const SUPPORTED: ReadonlyArray<LangType> = [Locale.EN, Locale.ID];
export const DISPLAY_LABEL: Record<LangType, LangDisplayType> = { [Locale.EN]: LangDisplay.EN, [Locale.ID]: LangDisplay.ID };
export const FROM_LABEL: Record<LangDisplayType, LangType> = { [LangDisplay.EN]: Locale.EN, [LangDisplay.ID]: Locale.ID };

export const NAV_LINKS = [
  {
    label: 'SMF Research Institute',
    href: 'https://research.smf-indonesia.co.id',
    external: true,
  },
];

export const LANGUAGE_LABELS: LangDisplayType[] = [LangDisplay.ID, LangDisplay.EN];
